import React from 'react'

export const ModalContents = ({ children, witdh = null }) => {
  return (
    <div className="modal-card" style={{ width: witdh }}>
      {children}
    </div>
  )
}
